import { inject } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { TokenService } from '@services/token-service';
import { from, ApolloLink } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { environment } from '@environments/environment';

export const apolloProvider = () =>
  provideApollo(() => {
    const tokenService = inject(TokenService);
    const httpLink = inject(HttpLink);

    const http = httpLink.create({ uri: `${environment.apiBase}graphql` });

    // WARNING: networkError is deprecated.
    // Middleware for network errror handling.
    // - Redirect to login if network error occurs.
    const onErrorHandler = onError(({ networkError }) => {
      if (networkError) {
        console.log('[GraphQL] network error, redirecting to login');
        console.log(networkError);

        window.location.href = '/auth/sign_in';
      }
    });

    // Middleware to run before each request.
    // - Fetch fresh headers from tokenService
    const beforeRun = new ApolloLink((operation, forward) => {
      operation.setContext({ headers: tokenService.currentAuthHeaders });

      return forward(operation);
    });

    // Middleware to run after each request.
    // - Refresh token from response headers
    const afterRun = new ApolloLink((operation, forward) =>
      forward(operation).map((response) => {
        const context = operation.getContext();

        if (context.response && context.response.headers) {
          tokenService.refreshTokenFromResponseHeaders(context.response.headers);
        }

        return response;
      })
    );

    return {
      link: from([onErrorHandler, beforeRun, afterRun, http]),
      cache: new InMemoryCache()
    };
  });
